query ListSMSES(
  $id: ID!
  $first: Int
  $last: Int
  $after: String
  $before: String
  $query: String
  $queryList: [QueryItemInput!]
) {
  smsRequestsForAccount(
    accountId: $id
    first: $first
    last: $last
    after: $after
    before: $before
    query: $query
    queryList: $queryList
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    edges {
      node {
        id

        insertedAt
        updatedAt

        processedAt
        deliveredAt
        expiredAt
        scheduledAt

        multipartId

        hostNumber
        remoteNumber

        direction

        status
        errorCode

        message

        displayBody

        priority

        encoding

        smppCommandStatus
        smppNeedDeliveryReceipt
        smppPriority

        remoteNeedDeliveryReceipt

        multipartMethod
        udhCount
        udhSeqNum
        udhRefNum

 

        remoteMessagingEnabled
        remoteReferenceId
        remoteCountryCode
        remoteTier

        idMapping {
          id
        }

        account {
          id
          name
        }
      }
    }
  }
}
